import { apiSlice } from "./apiSlice";
import { ordersListUrl } from "../config/config";

export const orderDetailSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ GET ORDER DETAIL
    getOrderDetail: builder.query({
      query: (orderId) => `${ordersListUrl}${orderId}`,
      transformResponse: (responseData) => {
        const { order_details = {}, shipment_details = {} } = responseData.data;

        const shipmentDetailArray = Object.entries(shipment_details).map(
          ([key, value], index) => ({
            id: index + 1,
            shipmentKey: key,
            title: key
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase()),
            ...value,
          }),
        );

        return {
          orderDetails: order_details,
          shipmentDetails: shipmentDetailArray,
        };
      },
      providesTags: ["orderDetail"],
    }),

    // ✅ UPDATE STATUS
    updateShipmentStatus: builder.mutation({
      query: ({ orderId, id, status }) => ({
        url: `${ordersListUrl}${orderId}`,
        method: "PATCH",
        body: { id, status },
      }),
      invalidatesTags: ["orderDetail"],
    }),

    // ✅ GET INVOICE
    getInvoice: builder.query({
      query: ({ orderId, shipment_id }) =>
        `${ordersListUrl}${orderId}/${shipment_id}/invoice`,
    }),

    // ✅ UPLOAD INVOICE
    uploadInvoice: builder.mutation({
      query: ({ orderId, shipment_id, file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: `${ordersListUrl}${orderId}/${shipment_id}/invoice`,
          method: "POST",
          body: formData,
        };
      },
    }),
    downloadInvoice: builder.query({
      query: ({ orderId, shipment_id }) => ({
        url:` ${ordersListUrl}${orderId}/${shipment_id}/invoice`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetOrderDetailQuery,
  useUpdateShipmentStatusMutation,
  useGetInvoiceQuery,
  useUploadInvoiceMutation,
  useLazyDownloadInvoiceQuery,
} = orderDetailSlice;